var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C3.36429 15 0 11.6357 0 7.5C0 3.36429 3.36429 0 7.5 0C11.6357 0 15 3.36429 15 7.5C15 11.6357 11.6357 15 7.5 15ZM7.5 1.89796C4.41122 1.89796 1.89796 4.41122 1.89796 7.5C1.89796 10.5888 4.41122 13.102 7.5 13.102C10.5888 13.102 13.102 10.5888 13.102 7.5C13.102 4.41122 10.5888 1.89796 7.5 1.89796ZM7.38701 5.76447C7.879 5.76447 8.27783 5.36563 8.27783 4.87365C8.27783 4.38166 7.879 3.98283 7.38701 3.98283C6.89503 3.98283 6.4962 4.38166 6.4962 4.87365C6.4962 5.36563 6.89503 5.76447 7.38701 5.76447ZM8.27772 11.0173H8.72772V9.82649H8.27772V6.60914H8.05425H6.72262H6.27874V7.79996H6.72262V9.82649H6.27261V11.0173H6.72262H8.27772Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.af307303e64bb1258ce6035e2e0b5e61.svg";
export { ForwardRef as ReactComponent };